import { render, staticRenderFns } from "./GColorPicker.vue?vue&type=template&id=72b41897&"
import script from "./GColorPicker.vue?vue&type=script&lang=js&"
export * from "./GColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./GColorPicker.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GColorPicker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports